import {CUSTOMER_EDIT} from "../../constant/ActionType";

export default function CustomerrEditReducer(state = {
    customerEditData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case CUSTOMER_EDIT:
			return { ...state,
				customerEditData: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
